import { render } from "./LegalLinksSection.vue?vue&type=template&id=6a0df394&scoped=true"
import script from "./LegalLinksSection.vue?vue&type=script&lang=js"
export * from "./LegalLinksSection.vue?vue&type=script&lang=js"

import "./LegalLinksSection.vue?vue&type=style&index=0&id=6a0df394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0df394"]])

export default __exports__